import { MenuItem, Select, BaseSelectProps } from "@mui/material";

interface Props extends BaseSelectProps {
  options: string[];
}

export default function SelectInputFromForm(props: Props) {
  const { value, options = [], ...rest } = props;

  return (
    <Select
      className="w-full"
      slotProps={{
        input: {
          className: "!rounded-xl !bg-white !px-4 !py-3",
        },
      }}
      variant="outlined"
      displayEmpty
      value={value ?? ""}
      {...rest}
    >
      <MenuItem disabled value="">
        Selecione uma opção…
      </MenuItem>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
}
